import React from "react";
import BackgroundBrothers from "./PageBackgrounds/BackgroundBrothers.jsx";
import "./Headers.css";
import Boogers from "../../media/Boogers.JPG";

export default function BrothersHeader() {
    return (
        <>
        <div className="Headers">
        <BackgroundBrothers />
        </div>
        </>
    );
}